import { render, staticRenderFns } from "./CustomerMessage.vue?vue&type=template&id=26aabcaa&scoped=true"
import script from "./CustomerMessage.vue?vue&type=script&lang=js"
export * from "./CustomerMessage.vue?vue&type=script&lang=js"
import style0 from "./CustomerMessage.vue?vue&type=style&index=0&id=26aabcaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26aabcaa",
  null
  
)

export default component.exports